import React from 'react';

const MpiDefaultRow = ({ item }) => (
  <>{item.name || item.description || 'Untitled'}</>
);

export default MpiDefaultRow;